"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../../gen-src/Localize");
var getStyles = function () {
    return {
        container: {
            marginTop: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
            marginBottom: widgets_1.TabStyles.Spacing.LargeSpace,
            textAlign: 'center',
        },
        title: {
            fontSize: 'larger',
            marginBottom: widgets_1.TabStyles.Spacing.LargeSpace,
        },
        message: {
            marginTop: widgets_1.TabStyles.Spacing.LargeSpace,
            fontSize: 'smaller',
        },
        footer: {
            height: '100%',
            textAlign: 'center',
        },
    };
};
var WaitingDialog = /** @class */ (function (_super) {
    __extends(WaitingDialog, _super);
    function WaitingDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.openTimeMs = 0;
        _this.wrappedOnCloseRequest = function () {
            // There are some concerns about using Date.now() for timing in JS. However, most of those concerns are due to the
            // gap in time between an event being fired and when the browser decides to execute the callback. This openDuration
            // isn't used for measuring perf, but for measuring the wait time before a user responds. Thus, we can tolerate the
            // imprecision that this method has.
            var closedTimeMs = Date.now();
            var openDurationMs = closedTimeMs - _this.openTimeMs;
            _this.props.onCloseRequest(openDurationMs);
        };
        _this.styles = getStyles();
        return _this;
    }
    WaitingDialog.prototype.componentDidMount = function () {
        // FIXME 'mount' does not necessarily mean 'shown to user'
        this.openTimeMs = Date.now();
    };
    WaitingDialog.prototype.renderDialogContent = function () {
        return (React.createElement("div", { style: this.styles.container },
            React.createElement("div", null,
                React.createElement("div", { style: this.styles.title }, this.props.title),
                React.createElement(widgets_1.ActivitySpinnerWidget, { testId: "waiting" })),
            this.props.message && (React.createElement("div", { style: this.styles.message, className: WaitingDialog.WaitingDialogMessageClass }, this.props.message))));
    };
    WaitingDialog.prototype.renderFooterContent = function () {
        return (React.createElement("div", { style: this.styles.footer },
            React.createElement(widgets_1.ButtonWidget, { handleClick: this.wrappedOnCloseRequest, buttonType: widgets_1.ButtonType.LowEmphasis, children: Localize_1.Messages.WaitingDialogOk(), testId: 'waiting-dialog-ok' })));
    };
    WaitingDialog.prototype.render = function () {
        var dialogProps = {
            shouldReturnFocusOnClose: false,
            zIndex: 1031,
            dialogWidth: 500,
            dialogStyle: {},
            type: widgets_1.DialogType.Uber,
            showCloseButton: false,
            onCloseRequest: this.wrappedOnCloseRequest,
            positioningBehavior: widgets_1.DialogPositioningBehavior.Centered,
            isModal: true,
            testId: this.props.testId,
            showFooter: this.props.showFooterButton,
            disableAutoFocus: !this.props.showFooterButton,
            footerContent: this.props.showFooterButton && this.renderFooterContent(),
        };
        return React.createElement(widgets_1.DialogWidget, __assign({}, dialogProps), this.renderDialogContent());
    };
    // Used for tests
    WaitingDialog.WaitingDialogMessageClass = 'waiting-dialog-message-class';
    return WaitingDialog;
}(React.Component));
exports.WaitingDialog = WaitingDialog;
//# sourceMappingURL=WaitingDialog.js.map